export default __webpack_public_path__ + "static/media/1716.9d5b10ad.png";